module.exports = __webpack_public_path__ + "img/home-section-2-img-3.6505b43b.png";